import { render, staticRenderFns } from "./Allies.vue?vue&type=template&id=1244eefb&scoped=true&"
import script from "./Allies.vue?vue&type=script&lang=js&"
export * from "./Allies.vue?vue&type=script&lang=js&"
import style0 from "./Allies.vue?vue&type=style&index=0&id=1244eefb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1244eefb",
  null
  
)

export default component.exports